export default "__VITE_ASSET__88f014d7__"